import {
  Home,
  Pill,
  Calendar,
  BookOpen,
  Award,
  Settings as SettingsIcon,
} from "lucide-react";

interface NavigationProps {
  currentView: string;
  onNavigate: (view: string) => void;
}

export function Navigation({ currentView, onNavigate }: NavigationProps) {
  const navItems = [
    { id: "today", label: "Today", icon: Home, tourId: "dashboard-tab" },
    { id: "presets", label: "Presets", icon: Pill, tourId: "presets-tab" },
    {
      id: "schedule",
      label: "Schedule",
      icon: Calendar,
      tourId: "schedule-tab",
    },
    { id: "history", label: "History", icon: BookOpen, tourId: "history-tab" },
    { id: "badges", label: "Badges", icon: Award, tourId: "badges-tab" },
    {
      id: "settings",
      label: "Settings",
      icon: SettingsIcon,
      tourId: "settings-tab",
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-warm-glass border-t border-warm safe-area-bottom z-50 warm-shadow-lg">
      <div className="flex justify-around items-center h-16 max-w-screen-lg mx-auto px-2 safe-area-x">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              data-tour={item.tourId}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-all duration-200 active:scale-90 ${
                isActive
                  ? "text-warm-secondary scale-110"
                  : "text-gray-500 hover:text-warm-dark hover:scale-105"
              }`}
            >
              <Icon
                size={24}
                strokeWidth={isActive ? 2.5 : 2}
                className={isActive ? "animate-bounce-in" : ""}
              />
              <span
                className={`text-xs mt-1 transition-all duration-200 ${
                  isActive ? "font-semibold" : "font-medium"
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
